import { useCallback } from 'react';

import { Flex } from 'common/flex';
import { PADDING } from 'constants/sizes';

import { SwitchProps } from './types';
import { SwitchContainer, Switch as StyledSwitch } from './styles';

export const Switch = ({
  value,
  onChange,
  leftLabel,
  rightLabel,
  disabled = false,
}: SwitchProps) => {
  const onClick = useCallback(() => {
    if (!disabled && onChange) {
      onChange(!value);
    }
  }, [disabled, value]);

  return (
    <Flex flexDirection="row" gap={PADDING.smallest} alignItems="center">
      {leftLabel && <p>{leftLabel}</p>}
      <SwitchContainer value={value} onClick={onClick}>
        <StyledSwitch />
      </SwitchContainer>
      {rightLabel && <p>{rightLabel}</p>}
    </Flex>
  );
};
